export default __webpack_public_path__ + "static/media/close-active.00a3e5ef.svg";